import { axiosGet } from "../../apis/useAxios";

/**
 * GET crew-notification/sos-new: { lastId, items: [{ id, title, message, entryTime }] }. Without afterId only the latest
 * SOS id comes back (the first check never alerts old SOS). A failed call throws; the next check retries.
 */
export async function getNewSos(airlineCode, afterId) {
  const params = { airlineCode };
  if (afterId) params.afterId = afterId;
  const response = await axiosGet("crew-notification/sos-new", params);
  if (!response || response.isSuccess === false) throw new Error(response?.message || "Unable to check for new SOS alerts.");
  return response.payload ?? { lastId: 0, items: [] };
}
